import(/* webpackMode: "eager", webpackExports: ["PrismeProvider"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/@bytel/logger-nextjs/dist/client.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(comparator)/_components/comparator.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(comparator)/_components/fai/fai-comparator.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(comparator)/_components/mobile/mobile-comparator-header.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(comparator)/_components/mobile/mobile-comparator-line.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(comparator)/_components/mobile/mobile-comparator.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(comparator)/_helpers/mobile-characteristics-group.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(comparator)/_helpers/use-fai-product-selection.ts");
